import React, { useState } from "react"
import { Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap"
import classnames from "classnames"

const Policy = () => {
  //meta title
  document.title = "السياسة | DBsaloni Admin & Dashboard"
  
  const [activeTab, setActiveTab] = useState("1")

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Page Header */}
          <Row>
            <Col lg={12}>
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">الشروط والأحكام</h4>
              </div>
            </Col>
          </Row>

          {/* Hero Section */}
          <Row>
            <Col lg={12}>
              <Card className="bg-primary text-white">
                <CardBody className="p-4">
                  <Row className="align-items-center">
                    <Col md={8}>
                      <h2 className="text-white mb-3">
                        <i className="bx bx-shield-quarter me-2"></i>
                        شروط وأحكام منصة DBSaloni
                      </h2>
                      <p className="text-white-50 mb-0 font-size-15">
                        يرجى قراءة هذه الشروط والأحكام بعناية قبل استخدام خدماتنا. 
                        باستخدامك للمنصة، فإنك توافق على جميع البنود المذكورة أدناه.
                      </p>
                    </Col>
                    <Col md={4} className="text-center">
                      <i className="bx bx-file-blank display-3 text-white-50"></i>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Main Content with Tabs */}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Nav tabs className="nav-tabs-custom nav-justified">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => toggleTab("1")}
                      >
                        <i className="bx bx-user-circle font-size-20 me-1"></i>
                        <span className="d-none d-sm-inline-block">شروط مزودي الخدمة</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "2" })}
                        onClick={() => toggleTab("2")}
                      >
                        <i className="bx bx-cog font-size-20 me-1"></i>
                        <span className="d-none d-sm-inline-block">الشروط العامة</span>
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab} className="p-3 text-muted">
                    {/* Tab 1: Provider Terms */}
                    <TabPane tabId="1">
                      <h4 className="card-title mb-4 text-primary">
                        <i className="bx bx-briefcase me-2"></i>
                        القسم الأول: الشروط والأحكام الخاصة بمزود الخدمة
                      </h4>
                  
                      <div className="policy-content" style={{ lineHeight: '1.9' }}>
                        {/* Section 1 */}
                        <Card className="shadow-sm border-0 mb-3">
                          <CardBody className="border-end border-4 border-primary">
                            <h5 className="text-dark mb-3">
                              <span className="badge bg-primary me-2">1</span>
                              حسابات مزودي الخدمات
                            </h5>
                            <ul className="list-unstyled ms-4">
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-primary me-2"></i>
                                يجب على مزود الخدمة إرفاق المستندات الرسمية والتراخيص والتصاريح على الايميل <span className="badge bg-soft-primary text-primary">info@dbsaloni.com</span>
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-primary me-2"></i>
                                يجب على مزود الخدمة تقديم وصف دقيق للخدمة وأسعارها وتوافرها.
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-primary me-2"></i>
                                يعمل مزودي الخدمة مستقلين وليس كموظفين dbsaloni.
                              </li>
                            </ul>
                          </CardBody>
                        </Card>

                        {/* Section 2 */}
                        <Card className="shadow-sm border-0 mb-3">
                          <CardBody className="border-end border-4 border-success">
                            <h5 className="text-dark mb-3">
                              <span className="badge bg-success me-2">2</span>
                              جودة الخدمة والمسؤوليات
                            </h5>
                            <ul className="list-unstyled ms-4">
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-success me-2"></i>
                                الحفاظ على السلوك المهني والنظافة والمواعيد.
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-success me-2"></i>
                                استخدام أدوات نظيفة والالتزام باللوائح الصحية.
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-success me-2"></i>
                                تقديم الخدمات على النحو الوارد في ملفهم الشخصي.
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-success me-2"></i>
                                احترام خصوصية العميل ومساحته الشخصية.
                              </li>
                            </ul>
                          </CardBody>
                        </Card>

                        {/* Section 3 */}
                        <Card className="shadow-sm border-0 mb-3">
                          <CardBody className="border-end border-4 border-info">
                            <h5 className="text-dark mb-3">
                              <span className="badge bg-info me-2">3</span>
                              الحجوزات والمدفوعات
                            </h5>
                            
                            <div className="mb-4">
                              <h6 className="text-info">
                                <i className="bx bx-check-circle me-1"></i>
                                3.1 قبول الحجوزات
                              </h6>
                              <ul className="list-unstyled ms-4">
                                <li className="mb-2">
                                  <i className="mdi mdi-chevron-left text-info me-2"></i>
                                  يمكن لمقدمي الخدمات قبول الحجوزات أو رفضها.
                                </li>
                                <li className="mb-2">
                                  <i className="mdi mdi-chevron-left text-info me-2"></i>
                                  بمجرد قبول الحجز يجب على مقدم الخدمة الوفاء بالخدمة.
                                </li>
                              </ul>
                            </div>

                            <div className="mb-4">
                              <h6 className="text-info">
                                <i className="bx bx-money me-1"></i>
                                3.2 شروط الدفع
                              </h6>
                              <ul className="list-unstyled ms-4">
                                <li className="mb-2">
                                  <i className="mdi mdi-chevron-left text-info me-2"></i>
                                  تتم معالجة مدفوعات العميل عبر المنصة ولا يُسمح بالدفع النقدي.
                                </li>
                                <li className="mb-2">
                                  <i className="mdi mdi-chevron-left text-info me-2"></i>
                                  يتلقى مزود الخدمة المدفوعات بعد الانتهاء من الخدمة مخصومًا منها عمولة dbsaloni حسب النسبة المتفق عليها بالعقد.
                                </li>
                                <li className="mb-2">
                                  <i className="mdi mdi-chevron-left text-info me-2"></i>
                                  يتحمل مزود الخدمات مسؤولية أي ضرائب والتزامات قانونية.
                                </li>
                              </ul>
                            </div>

                            <div className="mb-4">
                              <h6 className="text-danger">
                                <i className="bx bx-x-circle me-1"></i>
                                3.3 سياسة الإلغاء والتأخير
                              </h6>
                              <ul className="list-unstyled ms-4">
                                <li className="mb-2">
                                  <i className="mdi mdi-chevron-left text-info me-2"></i>
                                  يُتوقع من مزود الخدمة الوفاء بجميع الحجوزات المقبولة.
                                </li>
                                <li className="mb-2">
                                  <i className="mdi mdi-chevron-left text-info me-2"></i>
                                  إذا ألغى مزود الخدمة بعد دفع العميل:
                                  <div className="mt-2 ms-3">
                                    <div className="alert alert-warning border-0 mb-2">
                                      <i className="bx bx-info-circle me-1"></i>
                                      <strong>الإلغاءات لأول مرة:</strong> يتم إصدار تحذير.
                                    </div>
                                    <div className="alert alert-danger border-0 mb-2">
                                      <i className="bx bx-error me-1"></i>
                                      <strong>الإلغاءات المتكررة:</strong> بعد 3 إلغاءات قد يؤدي إلى الإيقاف أو الإزالة من المنصة وتطبق السياسات التالية:
                                    </div>
                                  </div>
                                </li>
                              </ul>
                              
                              <div className="mt-3">
                                <Row>
                                  <Col md={6}>
                                    <Card className="border border-success mb-3">
                                      <CardBody className="bg-soft-success">
                                        <div className="d-flex align-items-center mb-2">
                                          <div className="flex-shrink-0">
                                            <i className="bx bx-time-five display-6 text-success"></i>
                                          </div>
                                          <div className="flex-grow-1 ms-3">
                                            <h6 className="mb-0 text-success">أكثر من 24 ساعة</h6>
                                          </div>
                                        </div>
                                        <p className="mb-0 font-size-13">
                                          خصم فقط رسوم السداد الإلكتروني <strong>2.4% + 2 ريال</strong> إذا العميل طلب استرجاع المبلغ. في حال تعديل الحجز تتم بدون خصومات.
                                        </p>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                  <Col md={6}>
                                    <Card className="border border-danger mb-3">
                                      <CardBody className="bg-soft-danger">
                                        <div className="d-flex align-items-center mb-2">
                                          <div className="flex-shrink-0">
                                            <i className="bx bx-alarm-exclamation display-6 text-danger"></i>
                                          </div>
                                          <div className="flex-grow-1 ms-3">
                                            <h6 className="mb-0 text-danger">أقل من 24 ساعة</h6>
                                          </div>
                                        </div>
                                        <p className="mb-0 font-size-13">
                                          <strong>20 ريال</strong> كغرامة بالإضافة رسوم السداد الإلكتروني <strong>2.4% + 2 ريال</strong> في حال طلب العميل استرجاع المبلغ. في حال تعديل الحجز يتم خصم 20 ريال فقط.
                                        </p>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                                
                                <div className="alert alert-warning border-warning" role="alert">
                                  <div className="d-flex align-items-center">
                                    <i className="mdi mdi-clock-alert-outline font-size-20 me-2"></i>
                                    <div>
                                      <strong>سياسة التأخير:</strong> في حال تأخر مزود الخدمة عن الموعد المحدد دون إشعار مسبق أو سبب مقبول، يتم توجيه إنذار في المرة الأولى، وفي حال تكرار التأخير يتم فرض غرامة مالية قدرها <strong className="text-danger">(30) ريالًا سعوديًا</strong> عن كل حالة تأخير، غير شاملة ضريبة القيمة المضافة.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="alert alert-info border-info" role="alert">
                              <h6 className="alert-heading">
                                <i className="bx bx-wallet me-1"></i>
                                تحصيل الأموال
                              </h6>
                              <p className="mb-0">
                                جميع المدفوعات يتم تحويلها لمزودي الخدمة يوم من كل أسبوع ويتم حفظ سجلات المدفوعات وفقًا لممارسات وإجراءات وسياسات خدمات dbsaloni القياسية.
                              </p>
                            </div>
                          </CardBody>
                        </Card>

                        {/* Section 4 */}
                        <Card className="shadow-sm border-0 mb-3">
                          <CardBody className="border-end border-4 border-warning">
                            <h5 className="text-dark mb-3">
                              <span className="badge bg-warning me-2">4</span>
                              التقييمات والمراجعات
                            </h5>
                            <ul className="list-unstyled ms-4">
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-warning me-2"></i>
                                يمكن للعملاء ترك تقييمات ومراجعات مكتوبة بعد الانتهاء من الخدمة.
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-warning me-2"></i>
                                يحتفظ dbsaloni بالحق في إزالة المراجعات المزيفة أو المسيئة أو المضللة.
                              </li>
                            </ul>
                          </CardBody>
                        </Card>

                        {/* Section 5 */}
                        <Card className="shadow-sm border-0 mb-3">
                          <CardBody className="border-end border-4 border-danger">
                            <h5 className="text-dark mb-3">
                              <span className="badge bg-danger me-2">5</span>
                              الاشتراك وإنهاء الحساب
                            </h5>
                            <ul className="list-unstyled ms-4">
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-danger me-2"></i>
                                يجب أن يحافظ مزودي الخدمات على اشتراك نشط.
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-danger me-2"></i>
                                قد تتم إزالة مقدمي الخدمة بسبب الإلغاءات المتكررة أو التقييمات المنخفضة أو انتهاكات السياسة.
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-danger me-2"></i>
                                قد يتم إنهاء الحسابات بسبب الاحتيال أو سوء السلوك أو السلوك غير المهني وقد يعرضك للمسائلة القانونية بموجب قوانين المملكة العربية السعودية.
                              </li>
                            </ul>
                          </CardBody>
                        </Card>

                        {/* Section 6 */}
                        <Card className="shadow-sm border-0 mb-3">
                          <CardBody className="border-end border-4 border-secondary">
                            <h5 className="text-dark mb-3">
                              <span className="badge bg-secondary me-2">6</span>
                              مدونة قواعد السلوك
                            </h5>
                            <ul className="list-unstyled ms-4">
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-secondary me-2"></i>
                                يجب على مقدمي الخدمة التصرف بمهنية واحترام في جميع الأوقات.
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-secondary me-2"></i>
                                قد يؤدي التمييز أو السلوك غير المهني إلى إنهاء الخدمة فوراً وقد يعرضك للمسائلة القانونية بموجب قوانين المملكة العربية السعودية.
                              </li>
                            </ul>
                          </CardBody>
                        </Card>

                        {/* Section 7 */}
                        <Card className="shadow-sm border-0 mb-3">
                          <CardBody className="border-end border-4 border-dark">
                            <h5 className="text-dark mb-3">
                              <span className="badge bg-dark me-2">7</span>
                              إخلاء المسؤولية
                            </h5>
                            <ul className="list-unstyled ms-4">
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-dark me-2"></i>
                                لا يتحمل dbsaloni مسؤولية نزاعات العملاء أو الإصابات أو الأضرار الناتجة عن الخدمات.
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-dark me-2"></i>
                                يتحمل مقدمو الخدمات وحدهم المسؤولية عن جودة عملهم وأي مخاطر تنطوي عليها.
                              </li>
                            </ul>
                          </CardBody>
                        </Card>

                        {/* Section 8 */}
                        <Card className="shadow-sm border-0 mb-3">
                          <CardBody className="border-end border-4 border-primary">
                            <h5 className="text-dark mb-3">
                              <span className="badge bg-primary me-2">8</span>
                              الخصوصية وحماية البيانات
                            </h5>
                            <ul className="list-unstyled ms-4">
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-primary me-2"></i>
                                لا يقوم dbsaloni بمشاركة بيانات مزود الخدمة مع أطراف ثالثة دون موافقة.
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-primary me-2"></i>
                                تتم معالجة جميع المعاملات بشكل آمن داخل المنصة.
                              </li>
                            </ul>
                          </CardBody>
                        </Card>
                      </div>
                    </TabPane>

                    {/* Tab 2: General Terms */}
                    <TabPane tabId="2">
                      <h4 className="card-title mb-4 text-primary">
                        <i className="bx bx-info-circle me-2"></i>
                        القسم الثاني: شروط عامة
                      </h4>
                      
                      <div className="policy-content" style={{ lineHeight: '1.9' }}>
                        {/* General Section 1 */}
                        <Card className="shadow-sm border-0 mb-3">
                          <CardBody className="border-end border-4 border-success">
                            <h5 className="text-dark mb-3">
                              <span className="badge bg-success me-2">1</span>
                              مسؤوليات المنصة
                            </h5>
                            <ul className="list-unstyled ms-4">
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-success me-2"></i>
                                dbsaloni هو تطبيق يربط العملاء بمزودي الخدمات ولا يوظف مزودي خدمات.
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-success me-2"></i>
                                المنصة ليست مسؤولة عن تنفيذ الخدمة أو جودتها أو النزاعات.
                              </li>
                            </ul>
                          </CardBody>
                        </Card>

                        {/* General Section 2 */}
                        <Card className="shadow-sm border-0 mb-3">
                          <CardBody className="border-end border-4 border-warning">
                            <h5 className="text-dark mb-3">
                              <span className="badge bg-warning me-2">2</span>
                              التعديلات على الشروط
                            </h5>
                            <ul className="list-unstyled ms-4">
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-warning me-2"></i>
                                يحتفظ dbsaloni بالحق في تحديث هذه الشروط والأحكام في أي وقت.
                              </li>
                              <li className="mb-2">
                                <i className="mdi mdi-chevron-left text-warning me-2"></i>
                                سيتم إبلاغ المستخدمين (العملاء ومزودي الخدمات) بالتغييرات المهمة ويشير الاستمرار في استخدام المنصة إلى قبول الشروط المحدثة.
                              </li>
                            </ul>
                          </CardBody>
                        </Card>

                        {/* General Section 3 */}
                        <Card className="shadow-sm border-0 mb-3">
                          <CardBody className="border-end border-4 border-info">
                            <h5 className="text-dark mb-3">
                              <span className="badge bg-info me-2">3</span>
                              معلومات التواصل
                            </h5>
                            <div className="alert alert-info border-info mb-0" role="alert">
                              <div className="d-flex align-items-center">
                                <i className="bx bx-envelope font-size-24 me-3"></i>
                                <div>
                                  <p className="mb-1">للاستفسارات، أو الشكاوى، أو الدعم، يُرجى التواصل مع dbsaloni لخدمة العملاء عبر البريد الإلكتروني:</p>
                                  <h6 className="mb-0">
                                    <a href="mailto:info@dbsaloni.com" className="text-info">
                                      <i className="bx bx-mail-send me-1"></i>
                                      info@dbsaloni.com
                                    </a>
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </CardBody>
                        </Card>

                        {/* Final Notice */}
                        <Card className="bg-soft-primary border-primary mb-0">
                          <CardBody>
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0">
                                <i className="bx bx-check-shield display-4 text-primary"></i>
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <h5 className="text-primary mb-2">إقرار الموافقة</h5>
                                <p className="mb-0 text-muted">
                                  باستخدامك <strong>dbsaloni</strong> فإنك تقر بأنك قد قرأت هذه الشروط والأحكام وفهمتها ووافقت عليها بشكل كامل.
                                </p>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </div>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Policy
